import React, { Component, createRef } from "react";
import InputField from './input';
import ButtonField from './button';
import InputSelect from './select';
import InputDate from './date';
import '../../SCSS/input.scss';
import "../KenTable/index.scss";
import Button from '@material-ui/core/Button';
import InputRadio from './radio';
import InputTextArea from './text';
import InputCheckbox from './checkbox';
import TextField from '@material-ui/core/TextField';
import Axios from 'axios';
class KenForm extends Component {
    constructor() {
        super();
        this.state = {
            formData: [],
            formClass: undefined,
            formHeading: undefined,
            submitCheck: false,
            clear: false,
            libraryData: {}
        };
        this.formRef = React.createRef();
    }
    componentDidMount() {
        this.setState({ formData: this.props.formData, formClass: "", formHeading: "", clear: this.props.clear == undefined ? false : this.props.clear })
    }
    onSubmit = (e) => {
        e.preventDefault();
        let formElts = e.target.elements
        // console.log('***e***', e.target.elements.email.value)
        let submitCheck = false
        let fd = this.state.formData
        if (this.state.env['type'] === 'passive') {
            // var recptResp = (String(window.location.href).includes('login') || String(window.location.href).includes('register') || String(window.location.href) == "http://3.6.111.111:3000/#/") ?
            //     Axios.get(`${this.state.env['automationUri']}/34xfyEFCT914faghsrH35?contact=${localStorage.getItem('channel')}`) :
            //     { data: { Automation: "false" } }
            var recptResp = { data: { Automation: "false" } }
            fd.map(item => {
                if (item.required && item.requiredBoolean && item.category != 'button') {
                    if (item.category == "recaptcha") {
                        console.log(recptResp)
                        // .then(resp => {
                        if (recptResp.data.Automation == "true") {
                            submitCheck = submitCheck
                        } else {
                            if (!item.validation) {
                                submitCheck = true
                                item['error'] = true
                                item['errorMsg'] = `Invalid ${item.label}`
                            } else {
                                submitCheck = submitCheck
                                item['error'] = false
                            }
                        }
                        // })
                        // .catch(err => {
                        // })
                    } else {
                        if (!item.validation) {
                            submitCheck = true
                            item['error'] = true
                            item['errorMsg'] = `Invalid ${item.label}`
                        } else {
                            submitCheck = submitCheck
                            item['error'] = false
                        }
                    }
                }
                // if (item.type == 'submit') {
                //     this.props.onSubmit(e.target.elements, item)
                // }
            })
        } else {
            fd.map(item => {
                if (item.required && item.category != 'button') {
                    if (!item.validation) {
                        submitCheck = true
                        item['error'] = true
                        item['errorMsg'] = `Invalid ${item.label}`
                    } else {
                        submitCheck = submitCheck
                        item['error'] = false
                    }
                }
                // if (item.type == 'submit') {
                //     this.props.onSubmit(e.target.elements, item)
                // }
            })
        }
        this.setState({ submitCheck: submitCheck, formData: fd }, () => {
            if (!this.state.submitCheck) {
                let format = ""
                fd.map(item => {
                    if (item.type == "emailph") {
                        format = item.format
                    }
                    if (item.type == 'submit') {
                        this.props.onSubmit(formElts, item, this.props.formData, format)
                    }
                })
            }
        })
    }
    onInputChanges = (value, item, event, dataS) => {
        // this.props.onInputChanges(value, item, event, dataS)
        if (this.props.onInputChanges != undefined) {
            // if (dataS != undefined) {
            //     dataS['error'] = false
            // } else {
            //     if (item != undefined) {
            //         item['error'] = false
            //     }
            // }
            this.props.onInputChanges(value, item, event, dataS)
        }
        // let submitCheck = false
        // this.setState({ formData: this.state.formData }, () => {
        //     let fd = this.state.formData
        //     fd.map(item => {
        //         if (item.required) {
        //             if (!item.validation) {
        //                 submitCheck = true
        //             } else {
        //                 submitCheck = submitCheck
        //             }
        //         }
        //     })
        //     fd.map(item => {
        //         if (item.type == 'submit' && !submitCheck) {
        //             item['class'] = item['class'].replace('disabled-btn', '')
        //         } else if (item.type == 'submit' && submitCheck) {
        //             if (item['class'].includes("disabled-btn")) {
        //                 item['class'] = item['class']
        //             } else {
        //                 item['class'] = item['class'] + ' ' + 'disabled-btn'
        //             }
        //         }
        //     })
        //     this.setState({ formData: this.state.formData }, () => {
        //         this.setState({ submitCheck: submitCheck })
        //     })
        // })
    }
    onFormBtnEvent = (item) => {
        console.log('check')
        this.props.onFormBtnEvent(item)
    }
    onClearForm = (formDatas) => {
        console.log(formDatas, "formdtasa")
        formDatas.forEach(task => {
            if (task.clear == undefined) {
                delete task['defaultValue']
                task['required'] = task['requiredBoolean']
                task['validation'] = false
                task['error'] = false
            }
        })
        this.setState({ formData: [] }, () => {
            this.setState({ formData: formDatas })
        })
        // this.props.onClearForm(formDatas)
    }
    onTrAction = (type, item) => {
        if (this.props.onTrAction != undefined) {
            this.props.onTrAction(type, item)
        }
    }
    handleLibraryData = (e, name, item) => {
        console.log("e", e.target.value)
        let libraryData = this.state.libraryData;
        libraryData[name] = e.target.value;
        this.setState({ libraryData }, () => {
            if (this.props.handleLibraryData != undefined) {
                this.props.handleLibraryData(this.state.libraryData, item)
            }
        })

    }


    formatCurrency = (amount) => {
        return (new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount))
    }


    render() {
        return (
            <React.Fragment>
                {this.state.formData.length > 0 ? <form noValidate ref={this.formRef} className={this.props.formClass} onSubmit={(e) => { e.preventDefault(); this.props.onSubmit(e) }}>
                    {this.state.clear ? <Button variant="contained" type="clear" class="secondary-btn form-clear-btn goods-clr-btn service-clr-btn" onClick={(e) => { e.preventDefault(); this.onClearForm(this.state.formData) }}>Clear</Button> : null}
                    {this.props.formData.map((item, index) => {
                        if (item.category == 'input') {
                            return <InputField inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} onTrAction={this.onTrAction} />
                        }
                        if (item.type == 'select') {
                            return <InputSelect inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        }
                        if (item.type == 'date') {
                            return <InputDate inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        }
                        if (item.category == 'radio') {
                            return <InputRadio inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        }
                        if (item.category == "textarea") {
                            return <InputTextArea inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        }
                        if (item.type == "heading") {
                            return <p className={item.class}>{item.label}</p>
                        }
                        // if (item.category == "recaptcha") {
                        //     return <ZenRecaptcha inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        // }
                        if (item.category == 'button' && item.type == 'submit') {
                            return <ButtonField inputData={item} inputIndex={index} />
                        }
                        if (item.category == 'checkbox') {
                            return <InputCheckbox inputData={item} inputIndex={index} onInputChanges={this.onInputChanges} />
                        }
                        if (item.type == "cbText") {
                            return <div class="table-wrapper clear-both">
                                <div class="remove-last-child-table exits-table-wrap">
                                    <table class="zq-table-wrap" id="table-to-xls">
                                        <thead class="zq-table-heading">
                                            <tr>
                                                <th>
                                                    <span>Department</span>
                                                </th>
                                                <th>
                                                    <span>Dues from Employee</span>
                                                </th>
                                                <th>
                                                    <span>Dues to Pay Employee</span>
                                                </th>
                                                <th>
                                                    <span>Status</span>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody class="zq-table-body">
                                            <tr>
                                                <td><span>Library</span></td>
                                                <td className="input-wrap exit-form-wrap">
                                                    <TextField
                                                        defaultValue={item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.Duesempfrom != undefined ? item.defaultValue.librarianDataInformation.Duesempfrom : null : null : null}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "libraryDueToCollect", item) }}
                                                    >
                                                    </TextField>
                                                </td>
                                                <td className="input-wrap exit-form-wrap">
                                                    <TextField
                                                        defaultValue={item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.Duesempto != undefined ? item.defaultValue.librarianDataInformation.Duesempto : null : null : null}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "libraryDueToPay", item) }}
                                                    >
                                                    </TextField>
                                                </td>
                                                <td className={item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.status != undefined ? item.defaultValue.librarianDataInformation.status == "Completed" ? "Status-Done" : "Status-Pending" : "Status-Pending" : "Status-Pending" : "Status-Created"}><span>{item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.status != undefined ? item.defaultValue.librarianDataInformation.status : "Created" : "Created" : "Created"}</span></td>
                                            </tr>

                                            <tr>
                                                <td><span>Lab</span></td>
                                                <td className="input-wrap exit-form-wrap">
                                                    <TextField
                                                        defaultValue={Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom2 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom2) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom3 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom3) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom4 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom4) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom5 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom5) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom6 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom6) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom7 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom7) : null : null : null)}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "labDueToCollect", item) }}
                                                    >
                                                    </TextField>
                                                </td>
                                                <td className="input-wrap exit-form-wrap">
                                                    <TextField
                                                        defaultValue={Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto2 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto2) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto3 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto3) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto4 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto4) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto5 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto5) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto6 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto6) : null : null : null) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto7 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto7) : null : null : null)}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "labDueToPay", item) }}
                                                    >
                                                    </TextField>
                                                </td>
                                                <td className={item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.status != undefined ? item.defaultValue.labDataInformation.status == "Completed" ? "Status-Done" : "Status-Pending" : "Status-Pending" : "Status-Pending" : "Status-Created"}><span>{item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.status != undefined ? item.defaultValue.labDataInformation.status : "Created" : "Created" : "Created"}</span></td>
                                            </tr>

                                            <tr>
                                                <td><span>Office</span></td>
                                                <td className="input-wrap exit-form-wrap">
                                                    <TextField
                                                        defaultValue={item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.officeDuesempfrom != undefined ? item.defaultValue.officeDataInformation.officeDuesempfrom : null : null : null}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "officeDueToCollect", item) }}
                                                    >
                                                    </TextField>
                                                </td>
                                                <td className="input-wrap exit-form-wrap">
                                                    <TextField
                                                        defaultValue={item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.officeDuesempto != undefined ? item.defaultValue.officeDataInformation.officeDuesempto : null : null : null}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "officeDueToPay", item) }}
                                                    >
                                                    </TextField>
                                                </td>
                                                <td className={item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.status != undefined ? item.defaultValue.officeDataInformation.status == "Completed" ? "Status-Done" : "Status-Pending" : "Status-Pending" : "Status-Pending" : "Status-Created"}><span>{item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.status != undefined ? item.defaultValue.officeDataInformation.status : "Created" : "Created" : "Created"}</span></td>
                                            </tr>
                                            <tr>
                                                <td className="clearance-total"><span>Total</span></td>
                                                <td className="clearance-total2">
                                                    {this.formatCurrency(Number(item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.Duesempfrom != undefined ? Number(item.defaultValue.librarianDataInformation.Duesempfrom) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom2 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom2) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom3 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom3) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom4 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom4) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom5 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom5) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom6 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom6) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom7 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom7) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.officeDuesempfrom != undefined ? Number(item.defaultValue.officeDataInformation.officeDuesempfrom) : 0 : 0 : 0))}
                                                    {/* <TextField
                                                        defaultValue={Number(item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.Duesempfrom != undefined ? Number(item.defaultValue.librarianDataInformation.Duesempfrom) : 0 : 0 : 0) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempfrom2 != undefined ? Number(item.defaultValue.labDataInformation.Duesempfrom2) : 0 : 0 : 0) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.officeDuesempfrom != undefined ? Number(item.defaultValue.officeDataInformation.officeDuesempfrom) : 0 : 0 : 0)}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "financeDueToCollect", item) }}
                                                    >
                                                    </TextField> */}
                                                </td>
                                                <td className="clearance-total2">
                                                    {this.formatCurrency(Number(item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.Duesempto != undefined ? Number(item.defaultValue.librarianDataInformation.Duesempto) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto2 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto2) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto3 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto3) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto4 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto4) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto5 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto5) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto6 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto6) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto7 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto7) : 0 : 0 : 0) +
                                                        Number(item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.officeDuesempto != undefined ? Number(item.defaultValue.officeDataInformation.officeDuesempto) : 0 : 0 : 0))}
                                                    {/* <TextField
                                                        defaultValue={Number(item.defaultValue != undefined ? item.defaultValue.librarianDataInformation != undefined ? item.defaultValue.librarianDataInformation.Duesempto != undefined ? Number(item.defaultValue.librarianDataInformation.Duesempto) : 0 : 0 : 0) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.labDataInformation != undefined ? item.defaultValue.labDataInformation.Duesempto2 != undefined ? Number(item.defaultValue.labDataInformation.Duesempto2) : 0 : 0 : 0) +
                                                            Number(item.defaultValue != undefined ? item.defaultValue.officeDataInformation != undefined ? item.defaultValue.officeDataInformation.officeDuesempto != undefined ? Number(item.defaultValue.officeDataInformation.officeDuesempto) : 0 : 0 : 0)}
                                                        variant="filled"
                                                        type={"text"}
                                                        onChange={(e) => { this.handleLibraryData(e, "financeDueTopay", item) }}
                                                    >
                                                    </TextField> */}
                                                </td>

                                            </tr>

                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        }
                    })}
                </form> : null}
                {this.state.formData.length > 0 ? <React.Fragment>
                    {this.state.formData.map((item, index) => {
                        if (item.category == 'button' && item.type != 'submit') {
                            return <Button type={item.type} class={item.class} onClick={() => this.props.onFormBtnEvent(item)}>{item.label}</Button>
                        }
                    })}
                </React.Fragment> : null}
            </React.Fragment>
        )
    }
}
export default KenForm;